import getApiClient from '@/plugins/api-client'
import Vue from 'vue'

export default {
  loadTerms () {
    const api = getApiClient(this.$store)

    api.get('terms/latest')
      .then(result => {
        this.terms = result.data['hydra:member'][0]
      })
      .catch(error => {
        this.error = error.response
      })
  },

  save () {
    this.errors = {}
    const api = getApiClient(this.$store)
    const options = {}

    api.post('terms', { content: this.terms.content }, options)
      .then(() => {
        this.$store.commit('app/raiseSuccess', 'Termos de uso atualizados')
      })
      .catch(error => {
        if (error.response.status === 422) {
          this.parseErrors(error.response.data)
        }
        this.$store.commit('app/raiseError', 'Falha ao atualizar Termos de Uso')
      })
  },

  parseErrors (errors) {
    const self = this

    errors.violations.forEach(violation => {
      Vue.set(self.errors, violation.propertyPath, violation.message)
    })
  },
}
